/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import * as constants from './constants'
import * as signInConstants from './modules/signIn/constants'
import * as signUpConstants from './modules/signUp/constants'
import type { ActionTypes } from './types'

export const whitelist = [
  ...Object.values(constants),
  ...Object.values(signInConstants),
  ...Object.values(signUpConstants),
  // This satisfies makes sure that everything in the whitelist is also used in the reducer
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
declare const shouldBeEmpty: Exclude<
  ActionTypes['type'],
  (typeof whitelist)[number]
>
false && (shouldBeEmpty satisfies never)
